import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import ModalInfo from '../../../../theme/ui/Atoms/Modal/ModalInfo/ModalInfo';
import { useTranslation } from 'react-i18next';
import WorkspaceAPI from '../../../../redux/workspace/WorkspaceAPI';
import Button from '../../../../theme/ui/Atoms/Button/Button';
import useMessage from '../../../../shared/hooks/useMessage';
import useErrorMessage from '../../../../shared/hooks/useErrorMessage';

interface RemoveWorkspaceModalProps {
  displayConfirmModal: boolean;
  setDisplayConfirmModal: (display: boolean) => void;
  workspaceId: string | null;
}
export const RemoveWorkspaceModal = (props: RemoveWorkspaceModalProps) => {
  const { displayConfirmModal, setDisplayConfirmModal, workspaceId } = props;
  const { data: workspace } = WorkspaceAPI.useGetWorkspaceByIdQuery(
    workspaceId || ''
  );
  const [
    removeWorkspace,
    {
      isLoading: isRemovingWorkspace,
      isSuccess: isRemoveWorkspaceSuccess,
      isError: isRemoveWorkspaceError,
    },
  ] = WorkspaceAPI.useRemoveWorkspaceMutation();
  const { t } = useTranslation();
  const showMessage = useMessage();
  const showErrorMessage = useErrorMessage();

  const onDeleteClick = async () => {
    if (!workspaceId) return;
    try {
      await removeWorkspace(workspaceId);
      if (isRemoveWorkspaceSuccess) {
        setDisplayConfirmModal(false);
        showMessage(
          t('workspaces.workspace_deleted_successfully', {
            workspace: workspace?.name,
          })
        );
      }
      if (isRemoveWorkspaceError) {
        showErrorMessage(
          t('workspaces.workspace_error_deleted', {
            workspace: workspace?.name,
          })
        );
      }
    } catch (error) {
      showErrorMessage(
        t('workspaces.workspace_error_deleted', {
          workspace: workspace?.name,
        })
      );
    }
  };
  return (
    <ModalInfo
      open={displayConfirmModal}
      description={
        <Typography
          variant="body1"
          component={'p'}
          p="2rem 0 1rem 0"
          align="center"
        >
          {t('workspaces.delete_workspace_confirmation', {
            workspace: workspace?.name,
          })}
        </Typography>
      }
      title={
        <Typography fontSize="1.5rem" align="center">
          {t('workspaces.delete_workspace_name', {
            workspace: workspace?.name,
          })}
        </Typography>
      }
      buttonActions={
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-evenly"
          width={'100%'}
        >
          <Button
            autoFocus
            variant="outlined"
            rounded
            onClick={() => {
              setDisplayConfirmModal(false);
            }}
            sx={{ flex: '1 1 0px' }}
          >
            {t('button.cancel')}
          </Button>

          <Button
            autoFocus
            variant="contained-gray"
            rounded
            disabled={isRemovingWorkspace}
            onClick={onDeleteClick}
            sx={{ flex: '1 1 0px' }}
          >
            {isRemovingWorkspace ? (
              <CircularProgress size="1rem" />
            ) : (
              t('button.delete')
            )}
          </Button>
        </Stack>
      }
    />
  );
};
